import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useFacility } from '../context/FacilityContext';

const RequireSetup = ({ children }) => {
  const { configured, loading } = useFacility();
  if (loading) {
    return (
      <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!configured) return <Navigate to="/setup" replace />;
  return children;
};

export default RequireSetup;
